import styled from 'styled-components';
import { LeaderboardWidgetUI } from '../Leaderboard/LeaderboardWidgetUI';
import { SecuritySnapshotUI } from '../SecuritySnapshot/SecuritySnapshotUI';
import { TrainingWidget } from '../Activity/TrainingWidget';
import { ScoreBreakdown } from '../ScoreBreakdown/ScoreBreakdown';
import { withErrorBoundaries } from '../../lib/decorators/withErrorBoundaries';
import { ScoreBreakdownErrorCard } from '../ErrorView/ScoreBreakdownErrorCard';
import { TrainingWidgetErrorCard } from '../ErrorView/TrainingWidgetErrorCard';
import { LeaderboardWidgetErrorCard } from '../ErrorView/LeaderboardWidgetErrorCard';
import { Card } from '../Card';
import { SecuritySnapshotErrorCard } from '../ErrorView/SecuritySnapshotErrorCard';

const { SecuritySnapshotUI_WithErrorBoundary } = withErrorBoundaries({ SecuritySnapshotUI }, SecuritySnapshotErrorCard);
const { ScoreBreakdown_WithErrorBoundary } = withErrorBoundaries({ ScoreBreakdown }, ScoreBreakdownErrorCard);
const { TrainingWidget_WithErrorBoundary } = withErrorBoundaries({ TrainingWidget }, TrainingWidgetErrorCard);
const { LeaderboardWidgetUI_WithErrorBoundary } = withErrorBoundaries(
  { LeaderboardWidgetUI },
  LeaderboardWidgetErrorCard,
);

export const Overview: React.FC = () => {
  return (
    <PageFrame>
      <PageHero />
      <PageFade />
      <PageContent>
        <Layout>
          <Column>
            <SecuritySnapshotUI_WithErrorBoundary />
            <Card withShadow withBorder>
              <ScoreBreakdown_WithErrorBoundary />
            </Card>
          </Column>
          <Column>
            <LeaderboardWidgetUI_WithErrorBoundary />
            <TrainingWidget_WithErrorBoundary />
          </Column>
        </Layout>
      </PageContent>
    </PageFrame>
  );
};

const PageFrame = styled.div`
  position: relative;
  margin-top: calc(-1 * var(--layout-offset-top));
  margin-bottom: calc(-1 * var(--layout-offset-bottom));
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  min-height: calc(100vh - 64px);
  overflow: hidden;
  background: ${({ theme }) => theme.colors.prototype.background};
`;

const PageHero = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;
  background-image: url('/branding/background.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.75;
`;

const PageFade = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;
  background: linear-gradient(to bottom, transparent 38%, ${({ theme }) => theme.colors.prototype.background} 97%);
`;

const PageContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1440px;
  margin: 0 auto;
  padding: 142px 16px 36px;

  @media (max-width: 768px) {
    padding: 72px 16px 20px;
  }
`;

const Layout = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1fr) 340px;
  min-height: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;
